module.exports = __webpack_public_path__ + "img/gray-delete.38f58eb8.svg";